
export function SheetTab({
  label,
  active,
  badge,
  onClick,
}: {
  label: string;
  active: boolean;
  badge?: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "flex items-center gap-1.5 rounded-t border-x border-t px-3 py-1 text-[12px] font-medium transition",
        active
          ? "border-slate-300 dark:border-border bg-white dark:bg-surface text-slate-900 dark:text-slate-100"
          : "border-transparent text-slate-500 dark:text-slate-400 hover:bg-slate-200/70 dark:hover:bg-surface-2/70 hover:text-slate-800 dark:hover:text-slate-200",
      ].join(" ")}
    >
      {label}
      {badge && (
        <span
          className={[
            "rounded-full px-1.5 py-0.5 text-[10px]",
            active ? "bg-slate-900 dark:bg-slate-100 dark:text-slate-950 text-white" : "bg-slate-200 dark:bg-surface-2 text-slate-600 dark:text-slate-400",
          ].join(" ")}
        >
          {badge}
        </span>
      )}
    </button>
  );
}
